<template>
    <!-- *********************************************
    *                  Image Uploader                *
    ********************************************** -->
    <div class="image-uploader-wrapper">
		<!-- Web -->
		<profile-image-selector
        v-if="!getMobileAppState"
        @hasProfilePicture="emit('hasProfilePicture', $event)"/>
		<!-- Mobile -->
        <mobile-profile-image-uploader
        v-else
        @hasProfilePicture="emit('hasProfilePicture', $event)"/>
    </div>
</template>

<script setup>
import ProfileImageSelector from '@/components/generic/uploader/WebImageUploader'
import MobileProfileImageUploader from '@/components/generic/uploader/profileImageUploader/MobileImageUploader'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

const emit = defineEmits(['hasProfilePicture'])

/* mapGetters */
const { getMobileAppState } = mapGetters()
</script>

<style lang="scss" scoped>
.image-uploader-wrapper {
    display: flex;
    align-items: center;

    width: 100%;
    height: 100%;

    :deep(.profile-image-selector-wrapper) {
        display: flex;
        justify-content: center;

        height: 200px;

        margin: 0;
        border-radius: 16px;

        background-color: var(--secondary-light-4);
        box-shadow: var(--box-shadow-2);
    }
}
</style>
